import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { hostedNightscoutPlans } from "src/sections/pricing/hosted-nightscout-plans";
import {
  HostedNightscoutBillingCycleRadios,
  type HostedNightscoutBillingCycle,
} from "src/sections/pricing/hosted-nightscout-billing";
import {
  ServicePlanCard,
  getServicePlanIllustration,
} from "src/sections/pricing/service-plan-card";

export const NightscoutPage: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  usePageView();

  const [billingCycle, setBillingCycle] =
    useState<HostedNightscoutBillingCycle>("monthly");

  return (
    <>
      <Seo
        title="Hosted Nightscout"
        description="Hosted Nightscout in three steps. Pick a plan, connect your loop, and keep glucose data on a site you control instead of a vendor cloud."
        type="website"
      />
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          py: "120px",
          minHeight: "100vh",
        }}
      >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            component="h1"
            variant="h1"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
              mb: 2,
              fontSize: smDown ? "2rem" : "3rem",
              lineHeight: 1.2,
            }}
          >
            {t("Hosted Nightscout")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              fontSize: "1.125rem",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            {t("Hosted Nightscout in three steps")}
          </Typography>
          <HostedNightscoutBillingCycleRadios
            value={billingCycle}
            onChange={setBillingCycle}
            sx={{ alignItems: "center", mt: 3, mx: "auto", maxWidth: 480 }}
          />
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {hostedNightscoutPlans.map((service) => (
            <Grid xs={12} md={4} key={service.id}>
              <ServicePlanCard
                service={service}
                billingCycle={billingCycle}
                illustration={getServicePlanIllustration(service.id)}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
      </Box>
    </>
  );
};

export default NightscoutPage;
